import React, { useRef, useState, useEffect, useLayoutEffect } from "react";

export default function AssistantMenu(props) {
    const {
        showMenu, toggleMenu, toggleDailyMessage,
        toggleAnnouncements, toggleCopilotChat,
        unreadDailyMessages,
        unreadAnnouncements,
        unreadCopilotChatMessages,
        settings,
        menuRef,
        style,
        isDragging,
        onDragStart,
    } = props;

    const {
        useDailyMessage,
        useCopilotChat
    } = settings;

    const className = (showMenu ? "open" : "") + (isDragging ? " dragging" : "");
    return (
        <div id="assistant-menu" ref={menuRef} className={className} style={style}>
            <div id="assistant-menu-header" onMouseDown={onDragStart}>
                Mr. Pop: Asistente inteligente
                <div id="assistant-menu-close" onClick={toggleMenu}>
                    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="currentColor" class="bi bi-x" viewBox="0 0 16 16">
                        <path d="M4.646 4.646a.5.5 0 0 1 .708 0L8 7.293l2.646-2.647a.5.5 0 0 1 .708.708L8.707 8l2.647 2.646a.5.5 0 0 1-.708.708L8 8.707l-2.646 2.647a.5.5 0 0 1-.708-.708L7.293 8 4.646 5.354a.5.5 0 0 1 0-.708" />
                    </svg>
                </div>
            </div>
            <div id="assistant-menu-buttons">
                <div className="assistant-menu-button" onClick={toggleAnnouncements}>
                    Anuncios
                    {
                        unreadAnnouncements > 0 && <div className="assistant-menu-button-label">{unreadAnnouncements}</div>
                    }
                </div>
                <div className={"assistant-menu-button " + (!useDailyMessage ? "assistant-menu-button-disabled" : "")} id="assistant-menu-button" onClick={() => { if (useDailyMessage) { toggleDailyMessage() } }}>
                    Mensaje diario
                    {
                        useDailyMessage && unreadDailyMessages > 0 && <div className="assistant-menu-button-label">{unreadDailyMessages}</div>
                    }
                    {
                        !useDailyMessage && <div className="assistant-menu-button-label disabled-label">Deshabilitado</div>
                    }
                </div>
                <div className={"assistant-menu-button " + (!useCopilotChat ? "assistant-menu-button-disabled" : "")} onClick={() => { if (useCopilotChat) { toggleCopilotChat(); } }}>
                    Copilot
                    {
                        useCopilotChat && unreadCopilotChatMessages > 0 && <div className="assistant-menu-button-label">{unreadCopilotChatMessages}</div>
                    }
                    {
                        !useCopilotChat && <div className="assistant-menu-button-label disabled-label">Deshabilitado</div>
                    }
                </div>
            </div>
            <div id="assistant-menu-footer">
                © 2025 by PopEstate. Todos los derechos reservados.
            </div>
        </div>
    );
}
